import type { AutobidCmsConfig } from '@autobid/strapi-integration/typescript/Config'

export const useCmsConfig = () => {
  return useRuntimeConfig().public.autobidCMS as AutobidCmsConfig
}
